import http from '../util/http.js'

// 发送验证码
export function loginSendSms(params) {
    return http.post("/login/send_web_sms", params)
}

// 登录
export function webLogin(params) {
    return http.post("/login/web_login", params)
}

// 注册
export function webSet(params) {
    return http.post("/login/web_set", params)
}

// 获取门票列表
export function getUserTicket(params) {
    return http.post("/login/get_user_ticket", params)
}

// 忘记密码
export function updatePwd(params) {
    return http.post("/login/update_web_pwd", params)
}

// 券码查询
export function getTicketDetailsByCode(params) {
    return http.post("/activity_ticket/get_details", params)
}

// 门票生成
export function makeTicketByCode(params) {
    return http.post("/activity_ticket/get_ticket", params)
}

// 返回支付订单状态
export function getOrderStatus(params) {
    return http.post("/login/order_status", params)
}

// 交押金
export function payTicketDeposit(params) {
    return http.post("/login/ban_yajin", params)
}

// 返回押金订单状态
export function getYaOrderStatus(params) {
    return http.post("/login/ya_order_status", params)
}